/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { PriceDisplay } from '@/components/blocks/PriceDisplay';
import { useLocalization } from '@/data/Localization';
import { ProductDisplayPrice } from '@/data/types/Product';
import { Stack, Typography } from '@mui/material';
import { FC, useMemo } from 'react';
import { productCardListPriceSX, productCardOfferPriceSX } from './styles/price';

export const ProductCardPrice: FC<{price:ProductDisplayPrice}> = ({price}) => {
	const localization = useLocalization('PriceDisplay');
	const { offer, list, currency } = useMemo(()=>{
		return{
			offer:price?.offer??0,
			list:price?.list??0,
			currency:price?.currency??'€',
		}
	},[price]);

	return (
		<Stack direction="row" alignItems="center" columnGap={2}>
			{offer > 0 && offer < list ? (
				<Typography
					variant="body1"
					component="span"
					sx={productCardListPriceSX({list})}
					data-testid="list-price"
					id="list-price"
				>
					<PriceDisplay currency={currency} min={list} />
				</Typography>
			) : null}

			{offer > 0 ? (
				<Typography 
				variant="body1" 
				component="span" 
				data-testid="offer-price" 
				id="offer-price" 
				sx={productCardOfferPriceSX({list, offer})}
				>
					<PriceDisplay currency={currency} min={offer} />
				</Typography>
			) : null}

			{offer === 0 ? (
				<Typography variant="body1" component="span" data-testid="no-price" id="no-price">
					{localization.Labels.Pending.t()}
				</Typography>
			) : null}
		</Stack>
	);
};
